// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const PHOTO_UPLOAD_WRONG_IMAGE_FORMAT = "Nespr\u00e1vn\u00fd typ souboru. M\u00e1 m\u00edt p\u0159\u00edponu JPG, PNG nebo GIF";
